"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = require("prop-types");
var _constant = require("../Theme/constant");
var _constant2 = require("./constant");
var dataProps = {
  bundleCode: _propTypes.string,
  bundleId: _propTypes.string,
  type: _propTypes.string,
  designator: (0, _propTypes.shape)({
    arrivalStation: _propTypes.string,
    departureStation: _propTypes.string
  }),
  price: (0, _propTypes.shape)({
    price: _propTypes.number.isRequired,
    currency: _propTypes.string.isRequired
  }),
  guest: _propTypes.number,
  isAvailable: _propTypes.bool,
  currency: _propTypes.string,
  conversionRates: _propTypes.object,
  isIncluded: _propTypes.bool,
  upgradedTo: _propTypes.string
};
var _default = {
  PropTypes: {
    customProperties: _propTypes.object,
    accessible: _propTypes.bool,
    theme: _propTypes.string,
    data: (0, _propTypes.shape)(dataProps),
    selected: (0, _propTypes.shape)({
      departFlight: (0, _propTypes.shape)(dataProps),
      returnFlight: (0, _propTypes.shape)(dataProps)
    }),
    handleSelect: _propTypes.func,
    isDowngradable: _propTypes.bool,
    disableSelect: _propTypes.bool,
    shouldHideIfUnselected: _propTypes.bool,
    ctaVersion: (0, _propTypes.oneOf)(Object.keys(_constant2.CTA_VERSION)),
    isEconomy: _propTypes.bool
  },
  DefaultProps: {
    accessible: true,
    theme: _constant.DEFAULT_THEME,
    data: null,
    selected: null,
    handleSelect: null,
    isDowngradable: true,
    shouldHideIfUnselected: false,
    ctaVersion: _constant2.DEFAULT_VERSION,
    isEconomy: false,
    isLoading: false,
    disableButton: false
  }
};
exports.default = _default;